// src/shared/types/intent.ts — produced by controllers, consumed by tick.
// Canonical Intent + Vec2 contract (Phase 0 RESEARCH.md Pattern 2).

export interface Vec2 {
  x: number;
  y: number;
}

export interface IntentActions {
  sprint: boolean;
  toggleTorch: boolean;
  interact: boolean;
  shout: boolean;
  /** P3 D-21 — one-shot: tap to enter/exit a Tiled hiding-spot. */
  toggleHide: boolean;
  /** P3 D-25 — one-shot: drop to synthetic floor spot (character-ability gated). */
  dropToFloor: boolean;
  /** P3 D-21 — HELD while the hide button is long-pressed; NOT one-shot. */
  peek: boolean;
}

export interface Intent {
  move: Vec2;
  facing: number;
  actions: IntentActions;
}

/**
 * ZERO_INTENT is the identity Intent — no movement, idle facing, no actions.
 * Frozen so that a future controller stub that accidentally mutates it fails loudly.
 */
export const ZERO_INTENT: Intent = Object.freeze({
  move: Object.freeze({ x: 0, y: 0 }),
  facing: 0,
  actions: Object.freeze({
    sprint: false,
    toggleTorch: false,
    interact: false,
    shout: false,
    toggleHide: false,
    dropToFloor: false,
    peek: false,
  }),
}) as Intent;
